import { createFileRoute } from '@tanstack/react-router'
import { SensorKitSyncPage } from "@/sync/SensorKitSyncPage";

export const Route = createFileRoute('/sync/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SensorKitSyncPage/>
}
